import { createSelector } from 'reselect';

import { selectCurrentCoursePath } from '../Courses/selectors';

export function selectCoursePromoData(state) {
  return state.CoursePromoData;
}

export const selectCurrentCoursePromoData = createSelector(
  selectCurrentCoursePath,
  selectCoursePromoData,
  (currentCoursePath, coursePromoData) =>
    currentCoursePath && coursePromoData
      ? coursePromoData.getIn(['byCoursePath', currentCoursePath])
      : null
);

export const makeSelectCourseAllowsPrivateClassSelection = (coursePath) =>
  createSelector(
    selectCoursePromoData,
    (coursePromoData) =>
      coursePromoData
        ? coursePromoData.getIn(
            ['byCoursePath', coursePath, 'allowsPrivateClassSelection'],
            false
          )
        : false
  );
